<template>
  <div>
    <!-- Navigation Buttons -->
    <div id="outer-container">
      <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
        <div class="card-content">
          <div class="clearfix row pad-lf-10 pad-rg-10">
            <a class="btn btn-fill btn-primary" :class="{ active: isMyProfile }" @click="openTab ('myProfile')">{{$t('settingsPages.myProfile')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isUsers }" @click="openTab ('users')">{{$t('settingsPages.users')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isCompanyDetails }" @click="openTab ('companyDetails')">{{$t('settingsPages.companyDetails')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isPrinters }" @click="openTab ('printers')">{{$t('settingsPages.printers')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isDateTime }" @click="openTab ('dateTime')">{{$t('settingsPages.dateTime')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isCurrency }" @click="openTab ('currency')">{{$t('settingsPages.currency')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isServices }" @click="openTab ('services')">{{$t('settingsPages.services')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isPaymentGroups }" @click="openTab ('paymentGroups')">{{$t('settingsPages.paymentGroups')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isPush }" @click="openTab ('push')">{{$t('settingsPages.push')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isTaxLabeling }" @click="openTab ('taxLabeling')">{{$t('settingsPages.taxLabeling')}}</a>
            <a class="btn btn-fill btn-primary" :class="{ active: isMeasurementsUnits }" @click="openTab('measurementsUnits')">
              {{$t('settingsPages.measurementsUnits')}}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Contents -->
    <div v-if="isMyProfile">
      <user-form @on-submit="onUserSubmit" :callback="updateList" :userId="user && user.id ? user.id : null"></user-form>
    </div>

    <div v-if="isUsers">
      <template v-if="selectedUser != false">
        <user-form @on-submit="onUserSubmit" :callback="updateList" :userId="selectedUser"></user-form>
      </template>
      <template v-else>
        <users-list ref="userList" :isUsers="isUsers" :callback="getUser"></users-list>
      </template>
    </div>

    <div v-if="isCompanyDetails">
      <company-details
        :modeldata="model"
        :countries="defaultData.countries"
        :taxesData="taxes"
        :tabRefresh="currentTab"
        :isCompanyDetails="isCompanyDetails"
        @updateModelData="updateModelData"
        @setSelectedTab="setSelectedTab"
      ></company-details>
    </div>

    <div v-if="isPrinters">
      <printers :tabRefresh="currentTab" :isPrinters="isPrinters"></printers>
    </div>

    <div v-if="isDateTime">
      <datetime-form :modeldata="model" :defaultData="defaultData"></datetime-form>
    </div>

    <div v-if="isCurrency">
      <currency-form :modeldata="model" :currencylist="defaultData.currencies" :currencyformatlist="defaultData.currency_display_format"></currency-form>
    </div>

    <div v-if="isServices">
      <app-services ref="tableManagement" :modeldata="model" :isServices="isServices" :defaultData="defaultData"></app-services>
    </div>

    <div v-if="isPaymentGroups">
      <template v-if="selectedPaymentGroups != false">
        <payment-groups-form @on-submit="onUserSubmit" :callback="paymentGroupsUpdate" :paymentGroupId="selectedPaymentGroups"></payment-groups-form>
      </template>
      <template v-else>
        <payment-groups-list ref="paymentGroups" :isTable="isPaymentGroups" :callback="getPaymentGroups"></payment-groups-list>
      </template>
    </div>

    <div v-if="isPush">
      <push-notifications :modeldata="model.push_notifications" :locations="model.locations_details" :defaultData="defaultData['push_notifications']"></push-notifications>
    </div>

    <div v-if="isTaxLabeling">
      <tax-form :modeldata="model" :defaultData="defaultData" :taxesData="taxes" @setSelectedTab="setSelectedTab" @setTaxes="setTaxes"></tax-form>
    </div>

    <div v-if="isMeasurementsUnits">
      <template v-if="selectedMeasurementsUnits !== false">
        <measurements-units-form
          @on-submit="onUserSubmit"
          :callback="measurementsUnitsUpdate"
          :zoneId="selectedMeasurementsUnits"
        ></measurements-units-form>
      </template>
      <template v-else>
        <measurements-units-list
          ref="tableMeasurementsUnits"
          :isTable="isMeasurementsUnits"
          :callback="getMeasurementsUnits"
        ></measurements-units-list>
      </template>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Menu, MenuItem, MenuItemGroup, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import SettingsMenu from './SettingsMenu'
  import UsersList from './Users/Users.vue'
  import UserForm from './Users/UserForm.vue'
  import OrderingManagement from './../OrderingManagement/OrderingManagement'
  import TableManagementList from './TableManagement/TableManagement'
  import TableManagementForm from './TableManagement/TableManagementForm'
  import TableZoneList from './TableZones/TableZones'
  import TableZoneForm from './TableZones/TableZonesForm'
  import MeasurementsUnitsForm from './MeasurementsUnits/MeasurementsUnitsForm'
  import MeasurementsUnitsList from './MeasurementsUnits/MeasurementsUnits'
  import PaymentGroupsList from './PaymentGroups/PaymentGroups'
  import PaymentGroupsForm from './PaymentGroups/PaymentGroupsForm'
  import OrderScreen from 'src/components/Dashboard/Views/Screens/OrderScreen/OrderScreen.vue'
  import RewardForm from './../RewardProgram/RewardProgramForm.vue'
  import InfoPages from './../InfoPages/InfoPages.vue'
  import TaxForm from './Tabs/Taxes.vue'
  import TipsForm from './Tabs/Tips.vue'
  import AppForm from './Tabs/App.vue'
  import AppServices from './Tabs/Services.vue'
  import CompanyWebForm from './Tabs/CompanyWeb.vue'
  import locationGroups from './LocationGroups/LocationGroups.vue'
  import CompanyDetails from './Tabs/CompanyDetails.vue'
  import Printers from './Printer/Printers.vue'
  import CompanyLocations from './Tabs/CompanyLocations.vue'
  import Locations from './Locations/Location.vue'
  import CurrencyForm from './Tabs/Currency.vue'
  import DatetimeForm from './Tabs/DateTime.vue'
  import PushNotifications from './Tabs/PushNotifications.vue'
  import LocationGroupsForm from './LocationGroups/LocationGroupsForm.vue'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Menu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  Vue.use(DataTables)
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Menu.name]: Menu,
      [MenuItem.name]: MenuItem,
      [MenuItemGroup.name]: MenuItemGroup,
      [TimeSelect.name]: TimeSelect,
      SettingsMenu,
      UserForm,
      OrderingManagement,
      TableManagementList,
      TableManagementForm,
      TableZoneList,
      TableZoneForm,
      MeasurementsUnitsForm,
      MeasurementsUnitsList,
      PaymentGroupsList,
      PaymentGroupsForm,
      RewardForm,
      InfoPages,
      TaxForm,
      TipsForm,
      AppForm,
      AppServices,
      CompanyWebForm,
      locationGroups,
      CompanyDetails,
      CompanyLocations,
      Printers,
      Locations,
      CurrencyForm,
      DatetimeForm,
      PushNotifications,
      UsersList,
      LocationGroupsForm,
      OrderScreen
      // ProductOptions
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity']),
      formattedUsers () {
        return this.posUsers.map(user => ({
          ...user,
          fullname: `${user.firstname} ${user.lastname}` // Add a fullname field
        }))
      }
    },
    data () {
      return {
        posUsers: [],
        pickerOptions1: {},
        tabName: 'My Profile',
        currentTab: '',
        isMyProfile: true,
        isUsers: false,
        isCompanyDetails: false,
        isPrinters: false,
        isDateTime: false,
        isCurrency: false,
        isServices: false,
        isPaymentGroups: false,
        isPush: false,
        isTable: false,
        isTaxLabeling: false,
        isTableManager: false,
        isTableZones: false,
        isMeasurementsUnits: false,
        isCompanyWeb: false,
        selectedUser: false,
        selectedTable: false,
        selectedZone: false,
        selectedMeasurementsUnits: false,
        selectedPaymentGroups: false,
        selectedLocationGroups: false,
        pickerNames: ['date_from', 'date_to'],
        days: [
          this.$t('days.monday'),
          this.$t('days.tuesday'),
          this.$t('days.wednesday'),
          this.$t('days.thursday'),
          this.$t('days.friday'),
          this.$t('days.saturday'),
          this.$t('days.sunday')
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        mainCategories: [],
        optionTypes: ['checkbox', 'radiobox', 'dropdown'],
        locations: [],
        model: {},
        user: JSON.parse(this.$session.get('userData')),
        defaultData: {
          'available_languages': {},
          'countries': {},
          'currencies': {},
          'currency_display_format': [],
          'date_formats': [],
          'time_formats': [],
          'timezones': {},
          'push_notifications': []
        },
        timeformats: [
          { format: 'H:mm', example: '15:40' },
          { format: 'h:mm a', example: '3:40 pm' }
        ],
        dateformats: [
          { format: 'DD/MM/YYYY', example: '15/03/2018' },
          { format: 'MM/DD/YYYY', example: '03/15/2018' },
          { format: 'MMMM D, YYYY', example: 'March 15, 2018' }
        ],
        newLocation: {
          'street': '',
          'city': '',
          'state': '',
          'country': ''
        },
        modelValidations: {
        },
        modelValidate: {},
        taxes: [],
        websiteData: []
      }
    },
    created () {
      var data = {
        token: this.$session.get('token')
      }

      console.log('Created SettingsGeneral.vue', this.user)
      var self = this
      if (self.$session.get('userDataRole') === 'MARKETER') {
        self.$router.push('/products')
      }
      var companyID = this.$session.get('selectedCompany')

      this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
        if (response2.status === true) {
          self.model = response2.data[0]
          self.model.selected_languages = response2.data[0].languages.map(lang => ({
            value: lang.id,
            label: lang.name
          }))
        }
      })

      var taxesData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          self.defaultData = response.data[0]
          self.defaultData['push_notifications'] = response.data[0]['push_notifications']
        }
      })

      this.apiRequest('/settings/taxes', 'GET', taxesData, function (response) {
        if (response.status === true) {
          self.taxes = response.data
        }
      })

      this.apiRequest('/settings/website', 'GET', taxesData, function (response) {
        if (response.status === true) {
          self.websiteData = response.data
        }
      })

      let tab = this.$session.get('selectedTab')
      // console.warn('tab: ' + tab)
      if (tab !== undefined && tab !== '') {
        this.tabName = tab
        this.$session.set('selectedTab', '')
      }
      this.$bus.$on('upload', payload => {
        self.model.locations_details.forEach((value, index) => {
          if (value.id === payload.id) {
            value.upload = payload.file
          }
        })
      })
      this.$bus.$on('remove-upload', payload => {
        self.model.locations_details.forEach((value, index) => {
          if (value.id === payload.id) {
            value.upload = null
            value.qr_code = null
            value.qr_code_url = null
          }
        })
      })
      this.$bus.$on('upload-location-image', payload => {
        this.model.locations_details.forEach((value, index) => {
          if (value.id === payload.id) {
            this.model.locations_details[index][payload.field] = payload.file
          }
        })
      })
      this.$bus.$on('remove-upload-location-image', payload => {
        this.model.locations_details.forEach((value, index) => {
          if (value.id === payload.id) {
            this.model.locations_details[index][payload.field] = null
          }
        })
      })
      this.getPosUsers()
    },
    methods: {
      openTab (tab) {
        // Resetează toate tab-urile
        this.isMyProfile = false
        this.isUsers = false
        this.isCompanyDetails = false
        this.isPrinters = false
        this.isDateTime = false
        this.isCurrency = false
        this.isServices = false
        this.isPaymentGroups = false
        this.isPush = false
        this.isTaxLabeling = false
        this.isTableManager = false
        this.isTableZones = false
        this.isMeasurementsUnits = false
        this.isCompanyWeb = false

        // Activează tab-ul selectat
        switch (tab) {
          case 'myProfile': this.isMyProfile = true; break
          case 'users': this.isUsers = true; break
          case 'companyDetails': this.isCompanyDetails = true; break
          case 'printers': this.isPrinters = true; break
          case 'dateTime': this.isDateTime = true; break
          case 'currency': this.isCurrency = true; break
          case 'services': this.isServices = true; break
          case 'paymentGroups': this.isPaymentGroups = true; break
          case 'push': this.isPush = true; break
          case 'taxLabeling': this.isTaxLabeling = true; break
          case 'tableManager': this.isTableManager = true; break
          case 'tableZones': this.isTableZones = true; break
          case 'measurementsUnits': this.isMeasurementsUnits = true; break
          case 'companyWeb': this.isCompanyWeb = true; break
        }
      },
      getPosUsers () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status) {
            this.posUsers = response.data.pos_user
          }
        })
      },
      getData () {
        return []
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      addNewLocation () {
        let locationCopy = this.newLocation
        let newRow = []
        newRow = this.newLocation
        newRow.location_id = ''
        newRow.location_id = 'new_' + Math.round((Math.random() * 10000))

        if (this.locations === undefined) {
          this.locations = []
        }

        // console.warn(newRow)

        this.locations.push(newRow)
        this.newLocation = locationCopy

        // console.warn(this.locations)
      },
      goToRecordUser (row, event, column) {
        this.globalGoToRecord(row, event, column, '/user/edit/')
      },
      onUserSubmit (model, isValid) {
      },
      updateList () {
        this.selectedUser = false
        if (this.$refs.userList) {
          this.$refs.userList.getData()
        }
      },
      tableManagementUpdate () {
        this.selectedTable = false
        if (this.$refs.tableManagement) {
          this.$refs.tableManagement.getData()
        }
      },
      measurementsUnitsUpdate () {
        this.selectedMeasurementsUnits = false
        if (this.$refs.tableMeasurementsUnits) {
          this.$refs.tableMeasurementsUnits.getData()
        }
      },
      tableZoneUpdate () {
        this.selectedZone = false
        if (this.$refs.tableZone) {
          this.$refs.tableZone.getData()
        }
      },
      paymentGroupsUpdate () {
        this.selectedPaymentGroups = false
        if (this.$refs.paymentGroups) {
          this.$refs.paymentGroups.getData()
        }
      },
      getTable (id) {
        this.selectedTable = id
      },
      getMeasurementsUnits (id) {
        this.selectedMeasurementsUnits = id
      },
      getZone (id) {
        this.selectedZone = id
      },
      getPaymentGroups (id) {
        this.selectedPaymentGroups = id
      },
      getUser (id) {
        this.selectedUser = id
      },
      updateLocationGroups () {
        this.selectedLocationGroups = false
        if (this.$refs.LocationGroups) {
          this.$refs.LocationGroups.getData()
        }
      },
      getLocationGroups (id) {
        this.selectedLocationGroups = id
      },
      setSelectedTab (value) {
        this.tabName = value
      },
      setTaxes () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/settings/taxes', 'GET', data, (response) => {
          if (response.status === true) {
            this.taxes = response.data
          }
        })
      },
      updateModelData (data) {
        this.model = data
        if (data.languages) {
          this.model.selected_languages = data.languages.map(lang => ({
            value: lang.id,
            label: lang.name
          }))
        }
      }
      // handleTabChange (tabIndex, newTab, oldTab) {
      //   this.selectedUser = false
      //   this.selectedTable = false
      //   this.selectedZone = false
      //   this.selectedMeasurementsUnits = false
      //   this.selectedLocationGroups = false
      //   switch (newTab.title) {
      //     case this.$t('settingsPages.myProfile'):
      //       this.isMyProfile = true
      //       break
      //     case this.$t('settingsPages.users'):
      //       this.isUsers = true
      //       break
      //     case this.$t('settingsPages.companyDetails'):
      //       this.isCompanyDetails = true
      //       break
      //     case this.$t('settingsPages.printers'):
      //       this.isPrinters = true
      //       break
      //     case this.$t('settingsPages.companyLocations'):
      //       this.isCompanyLocations = true
      //       break
      //     case this.$t('settingsPages.locationGroups'):
      //       this.isLocationGroups = true
      //       break
      //     case this.$t('settingsPages.deliveryMethods'):
      //       this.isDeliveryMethods = true
      //       break
      //     case this.$t('settingsPages.tableManager'):
      //       this.isTable = true
      //       break
      //     case this.$t('settingsPages.tableZones'):
      //       this.isZone = true
      //       break
      //     case this.$t('settingsPages.measurementsUnits'):
      //       this.isMeasurementsUnits = true
      //       break
      //     case this.$t('settingsPages.services'):
      //       this.isServices = true
      //       break
      //     case this.$t('settingsPages.paymentGroups'):
      //       this.isPaymentGroups = true
      //       break
      //     case this.$t('settingsPages.companyWeb'):
      //       this.isCompanyWeb = true
      //       break
      //     case this.$t('pages.orderScreen'):
      //       this.isOrderScreen = true
      //       break
      //     default:
      //       this.isMyProfile = true
      //       break
      //   }
      // }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsGeneral.vue